import React from 'react';

export interface LabeledInputProps {
  label: string;
  value: string;
  placeholder?: string;
  description?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export function LabeledInput({ label, value, placeholder, description, onChange, disabled, onBlur, onKeyDown }: LabeledInputProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs uppercase tracking-wide text-neutral-400">{label}</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className="bg-black border border-neutral-700 rounded px-2 py-1 text-sm outline-none focus:ring-1 focus:ring-indigo-500 disabled:opacity-60"
      />
      {description && <p className="text-[11px] leading-snug text-neutral-500">{description}</p>}
    </div>
  );
}

export interface LabeledTextareaProps {
  label: string;
  value: string;
  placeholder?: string;
  description?: string;
  onChange: (value: string) => void;
  rows?: number;
  readOnly?: boolean;
}

export function LabeledTextarea({ label, value, placeholder, description, onChange, rows = 6, readOnly }: LabeledTextareaProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs uppercase tracking-wide text-neutral-400">{label}</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        readOnly={readOnly}
        className="bg-black border border-neutral-700 rounded px-2 py-2 text-xs font-mono outline-none focus:ring-1 focus:ring-indigo-500 read-only:opacity-80"
      />
      {description && <p className="text-[11px] leading-snug text-neutral-500">{description}</p>}
    </div>
  );
}

export interface LabeledSelectProps {
  label: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  description?: string;
}

export function LabeledSelect({ label, value, options, onChange, description }: LabeledSelectProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs uppercase tracking-wide text-neutral-400">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="bg-black border border-neutral-700 rounded px-2 py-1 text-sm outline-none focus:ring-1 focus:ring-indigo-500"
      >
        {options.map((opt) => (
          <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {description && <p className="text-[11px] leading-snug text-neutral-500">{description}</p>}
    </div>
  );
}
